<template>
  <a-modal
    v-model:visible="state.batchImportVisible"
    title="批量导入配置"
    :footer="null"
    :width="560"
  >
    <div class="batch-import">
      <div class="batch-import__tip">
        <span class="batch-import__tip-icon">📋</span>
        <span class="batch-import__tip-text">
          请先下载导入模板，按格式填写后上传
        </span>
        <a-button size="small" @click="state.downloadTemplate()">
          下载模板
        </a-button>
      </div>

      <a-upload-dragger
        v-if="state.batchImportFileList.length === 0"
        :file-list="state.batchImportFileList"
        :multiple="false"
        accept=".xlsx"
        :before-upload="() => false"
        @change="state.handleBatchImportChange"
      >
        <p class="ant-upload-drag-icon">
          <upload-outlined />
        </p>
        <p class="ant-upload-text">拖拽文件到此处，或 <a>点击上传</a></p>
        <p class="ant-upload-hint">支持 .xlsx 格式，文件大小不超过 10MB</p>
      </a-upload-dragger>
      <div v-else class="batch-import__file">
        <file-excel-outlined class="batch-import__file-icon" />
        <span>{{ state.batchImportFileList[0].name }}</span>
      </div>

      <div class="batch-import__footer">
        <a-button @click="state.closeBatchImport()">取消</a-button>
        <a-button
          type="primary"
          :disabled="state.batchImportFileList.length === 0"
          @click="state.confirmBatchImport()"
        >
          确定
        </a-button>
      </div>
    </div>
  </a-modal>
</template>

<script>
import { inject } from 'vue'
import { UploadOutlined, FileExcelOutlined } from '@ant-design/icons-vue'

export default {
  name: 'BatchImportModal',
  components: {
    UploadOutlined,
    FileExcelOutlined
  },
  setup() {
    const state = inject('initState')
    return { state }
  }
}
</script>

<style lang="scss" scoped>
.batch-import {
  &__tip {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 16px;
    background: #f0f5ff;
    border: 1px solid #d6e4ff;
    border-radius: 4px;
    margin-bottom: 16px;

    &-icon {
      font-size: 16px;
      flex-shrink: 0;
    }

    &-text {
      flex: 1;
      white-space: nowrap;
    }

    .ant-btn {
      flex-shrink: 0;
    }
  }

  &__file {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 16px;
    background: #f6ffed;
    border: 1px solid #b7eb8f;
    border-radius: 4px;
    margin-bottom: 16px;
    font-size: 13px;
    color: #333;

    &-icon {
      color: #52c41a;
      font-size: 18px;
      flex-shrink: 0;
    }
  }

  &__footer {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    margin-top: 16px;
  }
}
</style>
